export default "__VITE_ASSET__3H_j_o$l__"